module.exports = __webpack_public_path__ + "static/media/Trash.5e749e98.svg";